import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appDigitsOnly]'
})
export class DigitsOnlyDirective {

  regexStr = '^[0-9]*$';
  @Input() isAlphaNumeric: boolean;
  private isSanitizing = false;

  constructor(private el: ElementRef<HTMLInputElement>) { }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('input') onInput() {
    this.sanitizeAndSync();
  }

  @HostListener('paste') blockPaste() {
    setTimeout(() => this.sanitizeAndSync(), 0);
  }

  private sanitizeAndSync() {
    if (this.isSanitizing) {
      return;
    }

    const input = this.el.nativeElement;
    const currentValue = input.value || '';
    const sanitizedValue = currentValue.replace(/[^0-9]/g, '');

    if (currentValue === sanitizedValue) {
      return;
    }

    input.value = sanitizedValue;
    this.isSanitizing = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    this.isSanitizing = false;
  }

}
